var plugin_default = {
  "alignLeft": "ef-c8",
  "textWrapNowrap": "vLwck",
  "alignRight": "JYLEU",
  "alignCenter": "_1XrQh",
  "sizeFullWidth": "kuFyl",
  "renderedInTable": "dhLYh",
  "sizeOriginal": "cASXe",
  "sizeContent": "_4OBlC",
  "sizeSmall": "Nl--h",
  "sizeSmallCenter": "ebWjw",
  "flex": "_1Ygls",
  "atomic": "j3Tby",
  "embed": "oPYfV",
  "horizontalScrollbar": "l9D2A",
  "pluginContainerMobile": "t3b5E"
};
export {
  plugin_default as default
};
//# sourceMappingURL=plugin-scss.js.map
